import { FC } from 'react'

const ConfirmNotification: FC = () => {
  return (
    <div
      id='form_confirm'
      css={{
        padding: '15px',
        borderRadius: '5px',
        background: '#FFF',
      }}
    >
      <div css={{ fontWeight: 'bold', fontSize: '16px', color: '#000' }}>
        入力内容をご確認ください
      </div>
    </div>
  )
}

export default ConfirmNotification
